import { Component, OnInit } from "@angular/core";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import { BreadcrumbService } from "app/breadcrumb.service";
import { AppServiceManager } from "common/services/appServiceManager";
import { ActivatedRoute, Router } from "@angular/router";
import { MessageService, ConfirmationService } from "primeng/api";
import { IUser } from "app/shared/Domains/IUser";
import { AuthService } from "common/services/auth.service";
import { UntypedFormGroup } from "@angular/forms";
import { IRole } from "app/shared/Domains/role";
import { IService } from "app/services/models/service";
import { LanguageService } from 'app/LanguageService/Language.Service';
@Component({
    selector: "app-training-sessions",
    templateUrl: "./training-sessions.component.html",
    styleUrls: ["./training-sessions.component.css"],
})
export class TrainingSessionsComponent implements OnInit {
    calendarPlugins = [dayGridPlugin, interactionPlugin];
    userForm: UntypedFormGroup;
    trainingSessionsDialog: boolean = false;
    classSessionsDialog: boolean = false;
    loading: boolean = false;
    user: IUser;
    role:IRole;
    trainingSessions: any[];
    events: any[] = [
    ];
    scheduleOptions: any = {
    };
    memberName: string;
    trainerName: string;
    trainingSessionId: string;
    memberPerformanceArray: any[];
    memberPerformance: any;
    excerciseOptions: any[];
    selectedexcerciseOptions: any;
    reschedule: boolean = false;
    allowGeneralReschedule: boolean = true;
    allowPastReschedule : boolean = true;
    allowFutureReschedule : boolean = false;
    allowPastAttendance: boolean = false;
    allowFutureAttendance: boolean = false;
    allowAttendance: boolean = true;
    allowReschedule: boolean = true;
    status: string;
    services: IService[];
    selectedDate: Date = new Date();
    members: any[];
    classTrainerName: string;
    classTrainingSessionId: string;
    constructor(
        private LanguageService: LanguageService,
        private messageService: MessageService,
        private breadcrumbService: BreadcrumbService,
        private appServiceManager: AppServiceManager,
    ) {
    }

    hideModal() {
        this.trainingSessionsDialog = false;
        this.classSessionsDialog = false;

    }

    ngOnInit() {
        var date = new Date();
        this.services=[];
        this.user = AuthService.getLoggedInUser();
        this.role = AuthService.getLoggedInRole();
        this.getAllServices();
        this.scheduleOptions = {
            plugins: [dayGridPlugin, timeGridPlugin, interactionPlugin],
            defaultDate: date.toLocaleDateString(),
            height:'auto',
            displayEventTime: false,
            header: {
                left: "prev,next, today",
                center: "title",
                right: "dayGridMonth,timeGridWeek,timeGridDay",
            },
            eventClick: (info) => {
                console.log('Event clicked:', info.event);
                this.handleEventClick(info.event);
            }
        };

        this.getTrainingSessions();
        this.getMemberPerformance();
        this.getExcerciseOptions();
        this.breadcrumbService.setItems([
            { label: 'Training Sessions', routerLink: '/training-sessions' },
          ]);
    }

    setLabel(label) {
        return this.LanguageService.GetCurrentLanguage("TrainingSessionsComponent", label);
      }
    getAllServices() {
        this.appServiceManager.get("services/" + this.user.branch).subscribe(
          (res) => {
            if (res) {
              this.loading = false;
              this.services = res.response;
              console.log(res.response);
            } else {
              this.loading = false;
            }
          },
          (error) => {
            this.loading = false;
            console.log(error);
          }
        );
      }
    showDialog() {
        this.trainingSessionsDialog = true;
    }
    changeAttendedStatus(member) {
        member.attendedStatus = member.attendedStatus === 'ATTENDED' ? 'UNMARKED' : 'ATTENDED';
    }
    markClassAttendance(){
        for(let member of this.members){
            if (member.attendedStatus === "UNMARKED") {
                member.attendedStatus = "NO–SHOW";
            }
        }
        const url = `trainingSessions/markClassTrainingAttendance`;
        const body = { members: this.members};
        this.appServiceManager.put(url, body).subscribe((res: any) => {
            console.log('Attendance Marked', res);
            this.classSessionsDialog = false;
            this.getTrainingSessions();
        },
            (error) => {
                console.error('Attendance failed', error);
            }
        );
    }
    handleEventClick(event: any) {
        if(event.extendedProps.type == "classTraining"){
            // const serviceObj = this.services.filter( service => service._id == event.extendedProps.serviceId )[0];
            // this.allowGeneralReschedule=serviceObj.permissions.reschedule.generalReschedule;
            // this.allowPastReschedule=serviceObj.permissions.reschedule.pastReschedule;
            // this.allowFutureReschedule=serviceObj.permissions.reschedule.futureReschedule;
            // this.allowPastAttendance=serviceObj.permissions.attendance.pastAttendance;
            // this.allowFutureAttendance=serviceObj.permissions.attendance.futureAttendance;


            this.classTrainerName = event.extendedProps.trainerName;
            this.classTrainingSessionId = event.extendedProps.trainingSessionId;
            const eventStartDate = new Date(event.start);
            this.members = this.trainingSessions
                .filter(session => {
                    const sessionStartDate = new Date(session.startDate);
                    const sessionStartDateOnly = new Date(sessionStartDate.getFullYear(), sessionStartDate.getMonth(), sessionStartDate.getDate());

                    const eventStartDateOnly = new Date(eventStartDate.getFullYear(), eventStartDate.getMonth(), eventStartDate.getDate());

                    return session.trainerPackageId === event.extendedProps.trainerPackageId &&
                        sessionStartDateOnly.getTime() === eventStartDateOnly.getTime();
                })
                .map(session => {
                    return { id: session._id, name: session.subscriberName, attendedStatus: session.status };
                });
            this.members = this.members.filter(member => member.name !== undefined);
            let today= new Date();
            this.reschedule= false;
            today.setHours(0, 0, 0, 0);
            const eventDate = new Date(event.start);
            eventDate.setHours(0, 0, 0, 0);
            this.allowReschedule = true;
            // if(this.allowGeneralReschedule == false){
            //     this.allowReschedule = false;
            // }
            // else{
            //     if(this.allowPastReschedule == false && (eventDate < today)){
            //         this.allowReschedule = false;
            //     }
            //     else if(this.allowFutureReschedule == false && (eventDate > today)){
            //         this.allowReschedule = false;
            //     }
            // }
            this.classSessionsDialog = true;
        }
        else{
            const serviceObj = this.services.filter( service => service._id == event.extendedProps.serviceId )[0];

            this.allowGeneralReschedule=serviceObj.permissions.reschedule.generalReschedule;
            this.allowPastReschedule=serviceObj.permissions.reschedule.pastReschedule;
            this.allowFutureReschedule=serviceObj.permissions.reschedule.futureReschedule;
            this.allowPastAttendance=serviceObj.permissions.attendance.pastAttendance;
            this.allowFutureAttendance=serviceObj.permissions.attendance.futureAttendance;

            this.memberName = event.title;
            this.trainerName = event.extendedProps.trainerName;
            this.trainingSessionId = event.extendedProps.trainingSessionId;
            this.selectedexcerciseOptions = event.extendedProps.selectedexcerciseOptions;
            this.memberPerformance = event.extendedProps.memberPerformance;
            this.status = event.extendedProps.status;

            let today= new Date();
            this.reschedule= false;
            today.setHours(0, 0, 0, 0);
            const eventDate = new Date(event.start);
            eventDate.setHours(0, 0, 0, 0);
            this.allowAttendance = true;
            if(this.allowPastAttendance == false && (eventDate < today)){
                this.allowAttendance = false;
            }
            else if(this.allowFutureAttendance == false && (eventDate > today)){
                this.allowAttendance = false;
            }

            this.allowReschedule = true;
            if(this.allowGeneralReschedule == false){
                this.allowReschedule = false;
            }
            else{
                if(this.allowPastReschedule == false && (eventDate < today)){
                    this.allowReschedule = false;
                }
                else if(this.allowFutureReschedule == false && (eventDate > today)){
                    this.allowReschedule = false;
                }
            }
            this.trainingSessionsDialog = true;
        }
    }

    markPresent(){
        const url = `trainingSessions/markPresent/${this.trainingSessionId}`;
        const body = { exerciseOptions: this.selectedexcerciseOptions, memberPerformance: this.memberPerformance , status: "ATTENDED" };
        this.appServiceManager.put(url, body).subscribe((res: any) => {
            console.log('Attendance Marked', res);
            this.trainingSessionsDialog = false;
            this.getTrainingSessions();
        },
            (error) => {
                console.error('Attendance failed', error);
            }
        );
    }

    markAbsent(){
        const url = `trainingSessions/markAbsent/${this.trainingSessionId}`;
        const body = {  status: "NO–SHOW" };
        this.appServiceManager.put(url, body).subscribe((res: any) => {
            console.log('Attendance Marked', res);
            this.trainingSessionsDialog = false;
            this.getTrainingSessions();
        },
            (error) => {
                console.error('Attendance failed', error);
            }
        );
    }

    rescheduleSession(){
        const url = `trainingSessions/resechedule/${this.trainingSessionId}`;
        const body = {  date: this.selectedDate };
        this.appServiceManager.put(url, body).subscribe((res: any) => {
            console.log('Date changed', res);
            this.trainingSessionsDialog = false;
            this.reschedule=false;
            this.getTrainingSessions();
        },
            (error) => {
                console.error('Date changed failed', error);
            }
        );
    }
    rescheduleClassSession() {
        this.members;
        const url = `trainingSessions/resecheduleClass/${this.classTrainingSessionId}`;
        const body = {members:this.members,date: this.selectedDate };
        this.appServiceManager.put(url, body).subscribe((res: any) => {
            console.log('Date changed', res);
            this.classSessionsDialog = false;
            this.trainingSessionsDialog = false;
            this.reschedule = false;
            this.getTrainingSessions();
        },
            (error) => {
                console.error('Date changed failed', error);
            }
        );
    }
    getTrainingSessions() {
        this.trainingSessions = [];
        this.loading = true;
        let url;
        if(this.role.name =='Trainer'){
        url = `trainingSessions/company/${this.user.company}/branch/${this.user.branch}?trainerId=${this.user._id}`;
        }else{
        url = `trainingSessions/company/${this.user.company}/branch/${this.user.branch}`;
        }
        this.appServiceManager
            .get(
                url
            )
            .subscribe(
                (res) => {
                    if (res.length > 0) {
                        this.trainingSessions = res;
                        this.events = [];
                        this.trainingSessions.forEach(session => {
                            const startDateTime = new Date(session.startDate);
                            startDateTime.setHours(0, 0, 0, 0);
                            const endDateTime = new Date(session.startDate);
                            endDateTime.setHours(23, 59, 59, 999);
                            let color;
                            switch (session.status) {
                                case 'UNMARKED':
                                    color = 'blue';
                                    break;
                                case 'ATTENDED':
                                    color = 'green';
                                    break;
                                case 'NO–SHOW':
                                    color = 'red';
                                    break;
                                default:
                                    color = 'blue';
                            }
                            let event;
                            if (session.serviceType !== "selfService") {
                                if (session.sessionsType == "classTraining") {
                                    event = {
                                        title: "Class Training",
                                        start: startDateTime,
                                        end: endDateTime,
                                        trainerName: session.trainerName,
                                        serviceId: session.serviceId,
                                        trainingSessionId: session._id,
                                        trainerPackageId: session.trainerPackageId,
                                        memberPerformance: session.memberPerformance,
                                        selectedexcerciseOptions: session.exerciseOptions,
                                        status: session.status,
                                        type: session.sessionsType,
                                        color: color,
                                    };
                                }
                                else {
                                    if (session.trainingType !== "classTraining" || session.trainingType == undefined) {
                                        event = {
                                            title: session.subscriberName,
                                            start: startDateTime,
                                            end: endDateTime,
                                            trainerName: session.trainerName,
                                            serviceId: session.serviceId,
                                            trainingSessionId: session._id,
                                            memberPerformance: session.memberPerformance,
                                            selectedexcerciseOptions: session.exerciseOptions,
                                            status: session.status,
                                            color: color,
                                        };
                                    }

                                }
                            }
                            if(event){
                                this.events.push(event);
                            }
                        });
                    } else {
                        this.trainingSessions = [];
                        this.messageService.clear();
                        this.messageService.add({
                            severity: "info",
                            summary: "Info Message",
                            detail: "No Record Found",
                        });
                    }
                    this.loading = false;
                },
                (error) => {
                    this.loading = false;
                    this.messageService.clear();
                    this.messageService.add({
                        severity: "error",
                        summary: "Error Message",
                        detail: error,
                    });
                }
            );
    }
    getMemberPerformance(){
        this.memberPerformanceArray = [];
        this.appServiceManager
        .get(
            "trainingAttendance/memberPerformance"
        )
        .subscribe(
            (res) => {
                if (res.length > 0) {
                    res.forEach((element) => {
                        this.memberPerformanceArray.push({ name1: element.name, code1: element.name });
                    });
                } else {
                    this.messageService.clear();
                    this.messageService.add({
                        severity: "info",
                        summary: "Info Message",
                        detail: "No Record Found",
                    });
                }
                this.loading = false;
            },
            (error) => {
                this.loading = false;
                this.messageService.clear();
                this.messageService.add({
                    severity: "error",
                    summary: "Error Message",
                    detail: error,
                });
            }
        );

    }
    getExcerciseOptions(){
        this.excerciseOptions = [];
        this.appServiceManager
        .get(
            "trainingAttendance/excerciseOptions"
        )
        .subscribe(
            (res) => {
                if (res.length > 0) {
                    res.forEach((element) => {
                        this.excerciseOptions.push({ name2: element.name, code2: element.name });
                    });
                } else {
                    this.messageService.clear();
                    this.messageService.add({
                        severity: "info",
                        summary: "Info Message",
                        detail: "No Record Found",
                    });
                }
                this.loading = false;
            },
            (error) => {
                this.loading = false;
                this.messageService.clear();
                this.messageService.add({
                    severity: "error",
                    summary: "Error Message",
                    detail: error,
                });
            }
        );

    }


}
